module.exports = __webpack_public_path__ + "img/dl-btn-ios.abc64785.svg";